module.exports = __webpack_public_path__ + "static/media/Mohammad Salem_Dar.c828823e.jpg";